define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/widget/MessageDialog",
	"./CheckSyncOrUpdateAttributes"
], function(declare,lang,action,MessageDialog,CheckSyncOrUpdateAttributes) {

	return declare(CheckSyncOrUpdateAttributes, {
		_resetOperation: "CRGReinitializeMaterialCosts",
		_refreshOperation: "CRGUpdateAttributesFromBOM",

		_promptForReset: function() {
			this.confirmAction({
				buttons: this.m_action.m_id == "CheckSyncWithBOM" ? [MessageDialog.BUTTON_CANCEL, MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_RESET, "Refresh"] : [MessageDialog.BUTTON_CANCEL, "Refresh"],
				message: this.getString(action.SUFFIX_PROMPT + "Reset"),
				onResponse: lang.hitch(this, this._afterPromptForReset)
			});
		}

	});
});